import { gql } from "@apollo/client";

export const MARKETING_UNSUBSCRIBE_TOKEN_STATUS_QUERY = gql`
  query ($uid: String!, $token: String!) {
    marketingUnsubscribeTokenStatus(uid: $uid, token: $token)
  }
`;

export const EXISTING_REGISTRATION_DATA = gql`
  query {
    existingRegistrationData {
      educationLevels {
        id
        level
      }
      subjects {
        id
        name
      }
    }
  }
`;
export const GET_USER_PREFERENCES = gql`
  query {
    userPreferences {
      id
      data
    }
  }
`;
export const GET_USER_DETAILS = gql`
  query ($user: ID!) {
    userDetails(user: $user) {
      id
      fullName
      lastLogin
      isEmailVerified
      subscriptionStatus
      wondeLastSynced
      wondeId
      isActive
      schoolMemberships {
        id
        school {
          id
          name
        }
      }
      schoolGroupMemberships {
        id
        schoolGroup {
          id
          name
        }
      }
      roles {
        id
        educationLevels {
          id
          level
        }
        subjects {
          id
          name
        }
        role {
          id
          code
          name
        }
        school {
          name
        }
        schoolGroup {
          name
        }
      }
    }
  }
`;

export const GET_ALL_AVAILABLE_ROLES = gql`
  query {
    allAvailableRoles {
      id
      code
      name
    }
  }
`;

export const USER_QUERY = gql`
  query {
    user {
      id
      username
      firstName
      lastName
      email
      marketingEmailSuppressed
      marketingEmailSuppressionReason
      isEmailVerified
      subscribed
      subscriptionStatus
      hasBetaAccess
      isDemoUser
      roles {
        id
        role {
          id
          code
          name
        }
      }
      activeContext {
        contextType
        hasApprovedSubscription
        roleAssignment {
          id
          role {
            id
            code
            name
          }
          subjects {
            id
            name
          }
          educationLevels {
            id
            level
            yearGroups {
              id
              yearGroup
            }
          }
          school {
            id
            name
          }
          schoolGroup {
            id
            name
            schools {
              id
              name
            }
          }
        }
        moderator {
          id
          educationLevels {
            id
            name: level
          }
          subjects {
            id
            name
          }
        }
      }
      allowPersonalisation
      profilePictureUrl
    }
  }
`;

export const USER_DASHBOARD_QUERY = gql`
  query {
    dashboardData {
      approvalChecklist {
        assignmentCreated
        answersUploaded
        feedbackDownloaded
        assignmentsLevel {
          level
          current
          target
          percentage
        }
        answersLevel {
          level
          current
          target
          percentage
        }
      }
      dashboardStats {
        questionsCreatedStats {
          current
          previous
          successfulComparison
        }
        assignmentsDueStats {
          current
          previous
          successfulComparison
        }
        quizzesDueStats {
          current
          previous
          successfulComparison
        }
        answersViewedStats {
          current
          target
        }
        questionsReviewedStats {
          current
          previous
          successfulComparison
        }
      }
      activeRoleData {
        assignments {
          id
          name
          dueDate
          isPublished
          schoolClass {
            name
          }
          status
          tags {
            tag
          }
        }
        quizGroups {
          id
          name
          dueDate
          status
          isPublished
          schoolClass {
            name
          }
        }
        quizzes {
          id
          name
          dueDate
          status
          isPublished
          schoolClass {
            name
          }
        }
      }
    }
  }
`;
export const USER_REFERRAL_DATA = gql`
  query {
    referralStatus {
      code
      link
      otherSchoolReferrals
      sameSchoolReferrals
      totalReferrals
    }
  }
`;

export const ALL_USER_QUERY = gql`
  query (
    $searchString: String!
    $role: String
    $school: ID
    $schoolGroup: ID
    $subscriptionStatus: String
    $emailStatus: String
    $pseudonymisationStatus: String
    $first: Int
    $after: String
  ) {
    users(
      searchString: $searchString
      role: $role
      school: $school
      schoolGroup: $schoolGroup
      subscriptionStatus: $subscriptionStatus
      emailStatus: $emailStatus
      pseudonymisationStatus: $pseudonymisationStatus
      first: $first
      after: $after
    ) {
      edges {
        cursor
        node {
          id
          username
          firstName
          lastName
          email
          isActive
          isEmailVerified
          subscriptionStatus
          displayRoles
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

export const GET_ONBOARDING = gql`
  query {
    currentUserOnboarding {
      purpose
      eligible
      status
      version
      handledAt
    }
  }
`;
